// extracted by mini-css-extract-plugin
export default {"title":"admission-block-module--title--42ed4","button":"admission-block-module--button--7e073","wrapper":"admission-block-module--wrapper--687aa"};